module.exports = __webpack_public_path__ + "static/media/R2.7d316399.png";